import { RootState } from 'store/types';
import {
  AuthenticatePinData,
  AuthenticatePinState
} from 'store/billing/Payment/reducers/authenticate';
import get from 'lodash/get';

export const authenticatePinStateSelector = (state: RootState): AuthenticatePinState =>
  get(state, 'payment.authenticatePin') || {};

export const authenticatePinFetchingSelector = (state: RootState) =>
  get(state, 'payment.authenticatePin.isFetching');

export const authenticatePinErrorSelector = (state: RootState) =>
  get(state, 'payment.authenticatePin.error');

export const authentiatePinDataSelector = (state: RootState): AuthenticatePinData | null =>
  get(state, 'payment.authenticatePin.data');

export const jwtTokenSelector = (state: RootState) =>
  get(state, 'payment.authenticatePin.data.jwtToken');

export const mmiSelector = (state: RootState) =>
  get(state, 'payment.authenticatePin.data.guarantor.mmi');

export const PaymentInfoDataSelector = (state: RootState) => get(state, 'payment.paymentInfo.data');

export const PaymentInfoFetchingSelector = (state: RootState) =>
  get(state, 'payment.paymentInfo.isFetching');

export const ApplyPaymentDataSelector = (state: RootState) =>
  get(state, 'payment.applyPayment.data');

export const ApplyPaymentFetchingSelector = (state: RootState) =>
  get(state, 'payment.applyPayment.isFetching');

export const ApplyPaymentErrorSelector = (state: RootState) =>
  get(state, 'payment.applyPayment.error');
